<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>

        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
                <img class="avatar" :src="image" alt="avatar" :title="fullName" >
                <div class="fullname" >{{ fullName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab ripple>{{$t('message.Projects')}}</v-tab>
                <v-tab-item>
                    <div class="content">
                        <div class="content-left">
                            <v-text-field v-model="username" :label="$t('message.Username')" readonly></v-text-field>
                            <v-text-field v-model="firstName" :label="$t('message.FirstName')" readonly></v-text-field>
                            <v-text-field v-model="lastName" :label="$t('message.LastName')" readonly></v-text-field>
                            <v-text-field v-model="email" :label="$t('message.Email')" readonly></v-text-field>
                        </div>
                        <div class="sidebar-right">
                            <v-select :items="roles" v-model="role" :label="$t('message.Role')"></v-select>
                            <v-select :items="businessRoles" v-model="businessRole" :label="$t('message.Designation')"></v-select>
                            <v-autocomplete  v-model="companyId" :items="companies" :loading="isLoading" :search-input.sync="search" item-text="name" item-value="companyID" :label="$t('message.Company')" ></v-autocomplete>
                            <v-text-field v-model="lastLoginFormat" :label="$t('message.LastLogin')" disabled></v-text-field>
                            <v-text-field v-model="joinedFormat" :label="$t('message.Joined')" disabled></v-text-field>
                            <v-select :items="activeList" v-model="active" :label="$t('message.Active')"  item-text="name" item-value="id" ></v-select>
                        </div>
                    </div>
                </v-tab-item>
                 <v-tab-item> 
                   <member-projects-page :projectsLink="projectsLink"></member-projects-page>
                 </v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div> 
</template>

<script>
import MemberProjectsPage from "./MemberProjectsPage.vue";
import GenericRepository from "../../services/GenericRepository.js";
import MemberRepository from "../../services/MemberRepository.js";
import CompaniesRepository from "../../services/CompaniesRepository.js";
import HAL from "../../helpers/HAL.js";

export default {
  name: "MemberPage",
  computed: {
    computedPageHeight: function() {
      return this.pageHeight + "px";
    },
    fullName: function() {
      return this.firstName + " " + this.lastName;
    },
    joinedFormat: function() {
      return this.$moment(this.joined).format("DD.MM.YYYY");
    },
    lastLoginFormat: function() {
      return this.$moment(this.lastLogin).format("DD.MM.YYYY");
    }
  },
  components: {
    MemberProjectsPage
  },
  data() {
    return {
      pageHeight: 10,
      memberId: null,
      image: "",
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      businessRole: "",
      role: "",
      companyId: null,
      lastLogin: null,
      joined: "",
      active: false,
      updateLink: null,
      insertLink: "/api/members",
      backLink: "/member-list",
      roles: ["Admin", "User"],
      businessRoles: [
        "Managers",
        "Executives",
        "Business",
        "Scrum Masters",
        "Product Owners",
        "Team Members",
        "Developer",
        "Business Analysts",
        "Testers",
        "Technical Architects",
        "HR"
      ],
      activeList: [{ id: true, name: "Active" }, { id: false, name: "Disabled" } ],
      companies: [],
      isLoading: false,
      search: null,
      showmessage: false,
      alertMessage: '',
      projectsLink: ''
    };
  },
  methods: {
    goBack() {
      return "/member-list";
    },
    save() {
      var entity = {
        active: this.active,
        businessRole: this.businessRole,
        role: this.role,
        companyID: this.companyId,
        memberId: this.memberId
      };
      if (entity.memberId > 0) {
        GenericRepository.update(this.updateLink.href, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      } else {
        GenericRepository.insert(this.insertLink, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      }
    }
  },
  created() {
    this.pageHeight = window.innerHeight - 57 - 25 - 25;

    MemberRepository.getByID(this.$route.params.id).then(
      function(response) {
        if (response.data && response.data.status == "Success") {
          this.companies = response.data.company
            ? [
                {
                  companyID: response.data.company.companyId,
                  name: response.data.company.name
                }
              ]
            : [];
          this.memberId = response.data.memberId;
          this.image = response.data.image;
          this.firstName = response.data.firstName;
          this.lastName = response.data.lastName;
          this.email = response.data.email;
          this.username = response.data.username;
          this.role = response.data.role;
          this.businessRole = response.data.businessRole;
          this.companyId = response.data.company
            ? response.data.company.companyId
            : undefined;
          this.lastLogin = response.data.lastLogin;
          this.joined = response.data.joined;
          this.active = response.data.active;
          this.updateLink = HAL.getLink(response.data, "help:member-update");
          let link = HAL.getLink(response.data, "help:member-projects");
          this.projectsLink = link ? link.href : null;
        }
      }.bind(this)
    );
  },
  watch: {
    search(value) {
      if (!value || value.length < 3) return;

      if (this.isLoading) return;

      this.isLoading = true;

      CompaniesRepository.search(value)
        .then(response => {
          this.companies = HAL.getEmbededResources(
            response.data,
            "help:company"
          );
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style lang="stylus">
@import '../../assets/css/tool-bar.css'
@import '../../assets/css/entity-page.css'
</style>

<style lang="stylus" scoped>
    img.avatar {
        border-radius: 50%;
    }

    .content {
        padding: 24px;
        display: flex;
    }

    .content-left {
        flex: auto;
        padding-right: 24px;
    }

    .sidebar-right {
        padding-left: 24px;
        flex-basis: 250px;
        border-left: 1px solid #efefef;
    }
</style>

